// ── Purchase page "Questions" ─────────────────────────────────────────────────
// One list per payment rail (Jade, 2026-10-11): the Android app pays through
// Google Play, the website through PayMongo in the Philippines and Lemon
// Squeezy everywhere else. PremiumGateModal shows only the list for the rail
// the person is on. Answers must match what each rail really does, and the
// Play list must never name another way to pay (Play policy) — the test in
// src/utils/premiumFaqs.test.js checks that.
const SUPPORT_EMAIL = 'labsmilestone@gmail.com';

const PREMIUM_ENDS = {
  q: 'What happens when Premium ends?',
  a: 'Everything you made stays. Only the Premium extras lock again.',
};

// Website only: some extras don't exist in a browser (see ANDROID_ONLY_SUMMARY).
const WEB_FEATURES = {
  q: 'Does every Premium feature work on the website?',
  a: "Most do. Alarms, the app blocker and home-screen widgets need the Android app. There's no iPhone app at the moment, so on an iPhone you won't be able to use those three.",
};

const PLAY = [
  { q: 'How do I cancel?', a: 'Open the Play Store, tap your profile picture, then Payments & subscriptions → Subscriptions → Clarity → Cancel. You keep Premium until the end of the time you already paid for.' },
  { q: 'Will I be charged automatically?', a: 'Weekly, Monthly and Yearly renew automatically at the end of each period until you cancel. Lifetime is charged only once.' },
  { q: 'Can I get a refund?', a: `You can request one from your Google Play order history, or email us at ${SUPPORT_EMAIL}.` },
  { q: 'I got a new phone or reinstalled the app. Will I lose Premium?', a: 'No. Premium is saved to your Clarity account. Sign in with the same account and it comes back.' },
  { q: 'Does Premium work on the website too?', a: 'Yes. Sign in on the website with the same Clarity account.' },
  { q: 'Can my other Clarity accounts on this phone use it?', a: 'No. Premium stays with the account that bought it.' },
  { q: 'If I delete my Clarity account, does my subscription stop?', a: 'No. Cancel it in the Play Store first, or Google will keep charging you.' },
  PREMIUM_ENDS,
];

const PAYMONGO = [
  { q: 'What is PayMongo?', a: 'A Philippine payment company. It handles your payment for us, so you can pay with QR Ph.' },
  { q: 'How do I pay?', a: "With QR Ph: scan the QR code using GCash, Maya or your bank's app. Paying directly with GCash, Maya or a card is coming soon." },
  WEB_FEATURES,
  { q: 'Does it renew automatically?', a: "No. Each payment covers 7, 30 or 365 days. No card is saved and there's nothing to cancel." },
  // QR Ph refunds are paid out through a claim link PayMongo makes, not back to
  // the wallet the person paid from (PayMongo's QR Ph refund docs).
  { q: 'Can I get a refund?', a: `Yes. Email ${SUPPORT_EMAIL} within 14 days of paying for a full refund. We'll send you a link to claim the money, and Premium ends when the refund is made.` },
  { q: 'Is my payment safe?', a: 'Payments are handled by PayMongo. Clarity never sees your bank, e-wallet or card details.' },
  { q: 'Does Premium work in the Android app?', a: 'Yes. Sign in with the same Clarity account.' },
  PREMIUM_ENDS,
  { q: "Where's my receipt?", a: 'Your payment confirmation shows in your GCash, Maya or bank app.' },
];

const LEMON_SQUEEZY = [
  { q: 'What is Lemon Squeezy?', a: 'Our payment partner. It processes your payment as the official seller and takes care of the paperwork.', buy: true },
  { q: 'How do I pay?', a: 'By card, in US dollars. Your bank converts the amount to your currency.', buy: true },
  WEB_FEATURES,
  { q: 'Will I be charged automatically?', a: 'Weekly, Monthly and Yearly renew automatically until you cancel. Lifetime is charged only once.', buy: true },
  { q: 'How do I cancel?', a: `Go to app.lemonsqueezy.com/my-orders and sign in with the email you paid with (they email you a sign-in link). Open your Clarity order, tap Manage subscription, then Cancel. Or just email us at ${SUPPORT_EMAIL}. You keep Premium until the end of the time you already paid for.`, buy: true },
  { q: 'Can I get a refund?', a: `Yes. Email ${SUPPORT_EMAIL} within 14 days of paying for a full refund. If a renewal catches you by surprise, email us within 7 days of that charge and we'll refund it.`, buy: true },
  { q: 'Why is my price lower than the usual price?', a: "Some countries get a regional discount. It's applied automatically at checkout, and the Upgrade page already shows the discounted price.", buy: true },
  { q: 'Will I pay tax?', a: 'Lemon Squeezy adds any sales tax or VAT your country requires at checkout.', buy: true },
  { q: 'Does Premium work in the Android app?', a: 'Yes. Sign in with the same Clarity account.' },
  PREMIUM_ENDS,
];

// rail: 'play' | 'paymongo' | 'lemonsqueezy'. comingSoon = the Lemon Squeezy
// "coming soon" screen, where nothing can be bought yet: only the general
// questions are shown there.
export function premiumFaqs(rail, { comingSoon = false } = {}) {
  if (rail === 'play') return PLAY;
  if (rail === 'paymongo') return PAYMONGO;
  return comingSoon ? LEMON_SQUEEZY.filter((f) => !f.buy) : LEMON_SQUEEZY;
}
